import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { serializeSnProductMappingUpdate } from './serialize';

/**
 * 修改 物料序號。
 * PATCH `/aftersales/sn-product-mapping/{id}`
 *
 * @param {string} id
 * @param {object} payload
 */
export async function updateSnProductMapping(id, payload) {
  const { data: raw } = await request.patch(
    `/aftersales/sn-product-mapping/${id}`,
    serializeSnProductMappingUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
